import { useMutation } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { useActiveOrganization } from "@/hooks/organizations";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";
import { displayErrorToast } from "@/utils/toast";

export interface InvoicePaymentLinkRequest {
  organization_id: number;
}

export interface InvoicePaymentLinkResponse {
  success: boolean;
  invoice_id: string;
  invoice_url: string;
  amount_due: number;
  currency: string;
  status: string;
}

export const useInvoicePaymentLink = () => {
  const userToken = useAuth()?.userToken ?? "";
  const activeOrganization = useActiveOrganization();

  return useMutation({
    mutationFn: async (): Promise<InvoicePaymentLinkResponse> =>
      fetch(ENDPOINTS.billing.invoice_payment_link, {
        method: "POST",
        headers: jsonAuthHeaders(userToken),
        body: JSON.stringify({
          organization_id: activeOrganization.data?.id,
        }),
      }).then(handleResponse),
    onSuccess: (result: InvoicePaymentLinkResponse) => {
      window.location.href = result.invoice_url;
    },
    onError: (error: string) => {
      displayErrorToast(error);
    },
  });
};
